import React from 'react';
import { cn } from '../../lib/utils';

const Label = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <label
      ref={ref}
      className={cn('font-ui text-sm font-medium text-brand-ice/80 leading-none', className)}
      {...props}
    />
  );
});

Label.displayName = 'Label';

export { Label };
